import { CurrencyEnum, Employee, PriceIntervalEnum } from "@finway-group/shared/lib/models"
import React from "react"
import { useTranslation } from "react-i18next"

import PriceLabel from "Components/priceLabel"
import Loading from "Components/loading"
import { useCostCenterDataForEmployee } from "Shared/queries/analytics/costcenter.queries"

interface EmployeeCostCenterInterface {
    employee: Employee
    globalCurrency: CurrencyEnum
}
const EmployeeCostCenter: React.FC<EmployeeCostCenterInterface> = ({ employee, globalCurrency }) => {
    const { t } = useTranslation()
    const { data: costCenterData, isLoading } = useCostCenterDataForEmployee({
        employeeId: employee.id,
        destCurrency: globalCurrency,
    })

    return (
        <div className="overflow-hidden">
            {isLoading ? (
                <Loading className="h-150 mb-40" />
            ) : costCenterData?.length === 0 ? (
                <p>{t("missing:expense_data")}</p>
            ) : (
                <ul className="description-list">
                    {costCenterData?.map((data: any, index: number) => (
                        <li key={index}>
                            <span className="title truncate">{data?.costCenter}</span>
                            <span className="text">
                                <PriceLabel value={data?.value} currency={globalCurrency} interval={PriceIntervalEnum.ONE_TIME} showFullNumber />
                            </span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default EmployeeCostCenter
